import React, { useEffect, useRef, useState } from 'react';
import "./style.css"
import { Post } from '../../../types';
import { useAuth, useMessage, useTheme } from '../../../global-components/src';
import { Paperclip } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';
import ImgVerified from '../../imgVerified/ImgVerified';
import { calculateTime, errorMessage } from '../../../utils/TextManagerTwo';
import { PACOCA_API_URL } from '../../../global-components/src/utils/vars';
import axios from 'axios';
import { detectLanguage, isUserLang, translate } from '../../../global-components/src/utils/language';
import { censorText, clearText } from '../../../global-components/src/utils/text';
import hljs from 'highlight.js';
import { useTranslation } from 'react-i18next';

interface UserNameProps {
    post: Post;
    showFollow?: boolean;
    children?: any;
    showContentPost?: boolean;
    onFollow?: (isFollow: boolean, idUser: number) => void;
}

const UserName: React.FC<UserNameProps> = ({ post, showFollow, onFollow, showContentPost, children }) => {
    const { user, token } = useAuth();
    const { setMessage } = useMessage();
    const { isNewPacoca } = useTheme();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const user_post = post?.user;
    const user_exists = !!user_post;
    const is_community = post?.group_id && post?.group;
    var link = post?.group_id && post?.group ? `/comunidades/${[post?.group?.id]}` : `/@${post?.user?.user_name}`;
    var link_name = post?.group_id && post?.group ? post?.group?.name : (user_exists ? post?.user?.name : t("user.deletedUser")) as String
    var user_name = post?.group_id && post?.group ? (user_exists ? post?.user?.name : t("user.deletedUser")) : null
    const [isFollowing, setIsFollowing] = useState<boolean | undefined>();
    // var user_name = post?.group_id && post?.group ? (user_exists ? post?.user?.name : t("user.deletedUser")) : (user_exists ? `@${post?.user?.user_name}` : null)
    
    if(!user_exists){
        link = "#"
    }

    useEffect(() => {
        setIsFollowing(post?.is_following)
    }, [post?.is_following])


    const handleFollowUser = async () => {
        const newFollowing = !isFollowing;
        const url = PACOCA_API_URL + "/users/" + (newFollowing ? "follow" : "unfollow") + "/" + post?.id_user;
        if(onFollow) onFollow(newFollowing, user_post.id);
        else setIsFollowing(newFollowing);

        try {
            await axios.post(url, null, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            })

        } catch (err: any) {
            // const newisFollowing = isFollowing;
            // setIsFollowing(newisFollowing);
            // const messageError = errorMessage(err)
            // setMessage(messageError, "error")
            // console.error('Erro:', err);
        }
    }

    return (
        <div className={`col col-post ${!is_community ? "col-post-not-community" : "col-post-community"}`} onClick={() => navigate(`/post/${post?.id}`, { state: { post } })} style={{ cursor: "pointer" }}>
            <h2 onClick={(e) => e.stopPropagation()} className="cursor-pointer">
                <Link className={`${post?.group_id && post?.group ? "link-name-community" : ""} link-name`} to={link} state={!post?.group_id ? { user: post?.user } : undefined}>{link_name}</Link>
                {post?.group_id && post?.group ? null : (
                    <ImgVerified user={post?.user} classNameProp="user-select-none img-verificado-comentario" />
                ) }
                {post.has_is_following && !post?.group_id && user?.id != post?.id_user && String(link_name).length < 25 && showFollow ? (
                    <p onClick={handleFollowUser} className={`user-select-none p-follow-post ${!isFollowing ? "blue" : ""}`}>
                        {isFollowing ? t("user.follow.following") : t("user.follow.follow")}
                    </p>
                ) : null}

                {post?.group_id && (
                    <p className='text-date-post'>{post?.ads ? t("ads.label") : calculateTime(post?.created_at)}</p>
                )}
         
            </h2>

            {user_name?.trim().length  ? (
                <p className="seguidor-post cursor-pointer" onClick={(e) => { e.stopPropagation(); navigate(link, { state: !post?.group_id ? { user: post?.user } : undefined }); }} style={{ marginTop: -3 }}>
                    {user_name}

                    {post?.group_id && post?.group ? (
                        <ImgVerified user={post?.user} classNameProp="user-select-none img-verificado-com-grupo" />
                    ) : null }
                </p>
            ) : null}

            <p className='text-date-post'>
                {!post?.group_id && (
                    <>{post?.ads ? t("ads.label") : calculateTime(post?.created_at)}</>
                )}
                {post?.user?.pinned_post_id === post?.id ? (
                    <Paperclip className="icon-fixed-post" />
                ) : null}    
            </p>
            
            <span onClick={(e) => { e.stopPropagation(); }}>
                {showContentPost ? children : null}
            </span>
        </div>
    );
};

export default UserName;
